import { useEffect, type MutableRefObject } from 'react';

export function useTextareaAutoSize(
    textareaRef: MutableRefObject<HTMLTextAreaElement | null>,
    dependency: unknown,
    enabled = true
): void {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        const textarea = textareaRef.current;
        if (!textarea) {
            return;
        }

        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    }, [dependency, enabled, textareaRef]);
}
